import {
  tableV2NestedCarrierRowSx,
  tableV2NestedContentSx,
  tableV2NestedDetailCellSx,
} from '@/features/shared/components/tableSystem/TableV2NestedTable';
import {
  formatTableV2DateTime,
  formatTableV2PassRate,
  tableV2DateTimePrimarySx,
  tableV2RelativeTimeSx,
} from '@/features/shared/components/tableSystem/TableV2Primitives';
import { collapseExecutionStatusCountsWithTotal } from '@/features/shared/utils/projectStatusPresentation';
import type { ExecutionRunDto } from '@flowqa/shared';

export type ExecutionRunCounts = {
  total: number;
  passed: number;
  failed: number;
  errored: number;
  skipped: number;
  untested: number;
};

export const countSuites = (row: ExecutionRunDto): ExecutionRunCounts => ({
  total:
    (row.suiteRunPassed ?? 0) +
    (row.suiteRunFailed ?? 0) +
    (row.suiteRunErrored ?? 0) +
    (row.suiteRunSkipped ?? 0) +
    (row.suiteRunUntested ?? 0),
  passed: row.suiteRunPassed ?? 0,
  failed: row.suiteRunFailed ?? 0,
  errored: row.suiteRunErrored ?? 0,
  skipped: row.suiteRunSkipped ?? 0,
  untested: row.suiteRunUntested ?? 0,
});

export const countTests = (row: ExecutionRunDto): ExecutionRunCounts => ({
  total:
    (row.testRunPassed ?? 0) +
    (row.testRunFailed ?? 0) +
    (row.testRunErrored ?? 0) +
    (row.testRunSkipped ?? 0) +
    (row.testRunUntested ?? 0),
  passed: row.testRunPassed ?? 0,
  failed: row.testRunFailed ?? 0,
  errored: row.testRunErrored ?? 0,
  skipped: row.testRunSkipped ?? 0,
  untested: row.testRunUntested ?? 0,
});

export const collapseExecutionRunCounts = (
  counts: ExecutionRunCounts,
  groupErroredWithFailed: boolean,
): ExecutionRunCounts => ({
  ...collapseExecutionStatusCountsWithTotal(counts, groupErroredWithFailed),
});

export const formatPassRate = (counts: ExecutionRunCounts): string => formatTableV2PassRate(counts);

export const formatUploadedAt = (value: Date | string | null | undefined): string =>
  formatTableV2DateTime(value);

export const dateTimePrimarySx = tableV2DateTimePrimarySx;

export const relativeTimeSx = tableV2RelativeTimeSx;

export const nestedCarrierRowSx = tableV2NestedCarrierRowSx;
export const nestedDetailCellSx = tableV2NestedDetailCellSx;
export const nestedDetailContentSx = tableV2NestedContentSx;
